import router from './router'
import useDiscountStore from './store'
import DiscountMessages from './localization'

export default {
  router,
  useDiscountStore,
  localization: DiscountMessages,
}
